export enum UnavailableSlotType {
  CreatedBySystem = 1,
  CreatedByUser = 2,
  CreatedByMovement = 3,
}
